import React, { useEffect, useState } from 'react';
import "../../styles/home/notification.css";
import { Link } from 'react-router-dom';
import { getAllHomeData } from '../../Services/AllAPIs';

const Notification = () => {

    const [loader, setLoader] = useState(true);
    const [notice, setNotice] = useState([]);
    const [event, setEvent] = useState([]);
    const [error, setError] = useState(null);

    // Fetch notification and event data
    const getNotification = () => {
        getAllHomeData()
            .then((res) => {
                const notices = res.data.home.notification.Notice.news;
                const events = res.data.home.notification.Events.news;

                // Check if notices and events are arrays
                if (Array.isArray(notices)) {
                    setNotice(notices);
                } else {
                    console.error('Notice news is not an array:', notices);
                    setNotice([]);
                }

                if (Array.isArray(events)) {
                    setEvent(events);
                } else {
                    console.error('Events news is not an array:', events);
                    setEvent([]);
                }

                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching the notifications.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getNotification();
    }, []);

    // Function to format date as DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');

        // Month names
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();

        return `${day} ${month} ${year}`;
    };


    if (loader) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <>
            <div className="notices mt-5 py-5">
                <div
                    className="d-flex justify-content-center"
                    style={{ backgroundColor: "#14297a", padding: 5 }}
                >
                    <h1 className="my-heading text-white m-0">News and Notification</h1>
                </div>
                <div className="container notices-main">
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className="tab-pane fade show active"
                            id="pills-history"
                            role="tabpanel"
                            aria-labelledby="pills-history-tab"
                        >
                            <div className="notice" id="student">
                                {/* Notifications Section */}
                                <div className="col-lg-6 box">
                                    <div className="top">
                                        <div className="left">
                                            <h1>NOTIFICATIONS/ PRESS RELEASE</h1>
                                        </div>
                                        <div className="right">
                                            <Link to="/search-news?category=Notice&page=1" className="normal-button">
                                                View all
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="down custom-scroll">
                                        {notice.map((item, index) => (
                                            <div className="single" key={index}>
                                                <p className="date">{formatDate(item.created_at)}</p>
                                                <Link to={item.url} className="notify" target="_blank">
                                                    {item.title} <span>New</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Events Section */}
                                <div className="col-lg-6 box">
                                    <div className="top">
                                        <div className="left">
                                            <h1>Events</h1>
                                        </div>
                                        <div className="right">
                                            <Link to="/search-news?category=Events&page=1" className="normal-button">
                                                View all
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="down custom-scroll">
                                        {event.map((item, index) => (
                                            <div className="single" key={index}>
                                                <p className="date">{formatDate(item.created_at)}</p>
                                                <Link to={item.url} className="notify" target="_blank">
                                                    {item.title} <span>New</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;
